import { render } from "./UserPermissionList.vue?vue&type=template&id=0539d454&scoped=true"
import script from "./UserPermissionList.vue?vue&type=script&lang=js"
export * from "./UserPermissionList.vue?vue&type=script&lang=js"

import "./UserPermissionList.vue?vue&type=style&index=0&id=0539d454&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0539d454"]])

export default __exports__